/** Lower preference_rank wins at resolve. New members use 1, then max+1, capped at 10. */
export const MFG_MATERIAL_USE_PREF_RANK_CAP = 10;

export function nextMaterialUsePreferenceRank(
  members: readonly { preference_rank: number; is_active?: boolean }[],
): number {
  const active = members.filter((m) => m.is_active !== false);
  if (active.length === 0) return 1;
  const max = Math.max(...active.map((m) => m.preference_rank));
  if (!Number.isFinite(max)) return 1;
  return Math.min(MFG_MATERIAL_USE_PREF_RANK_CAP, Math.trunc(max) + 1);
}

export function clampMaterialUsePreferenceRank(rank: number): number {
  if (!Number.isFinite(rank)) return 1;
  return Math.min(MFG_MATERIAL_USE_PREF_RANK_CAP, Math.max(1, Math.trunc(rank)));
}
